import SummaryCard from "../SummaryCard/SummaryCard";
function EmissionSummary({ data, type, onEmit, dataInformation = null }) {
    return (
        <div>
            <SummaryCard
                data={data}
                type={type}
                hideDownload={true}
                dataInformation={dataInformation}
                onEmit={onEmit}
            />
        </div>
    );
}

export default EmissionSummary;
